import { Box, Grid, Stack, Typography, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import React from 'react';
import { getRunTimeEnv } from '../../../util/getEnvVariable';
import { BLUR_DATA_URL } from '../../../util/imageConstants';
import { useStyles } from '../style';

/**
 * @name FeaturedImage
 * @description Displays featured image based on nav links
 * @param {object} root0  - destructured object
 * @param {string} root0.nav - Data from Strapi
 * @returns {JSX.Element} ReactJs Element
 */
const FeaturedImage = ({ nav }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const clientSideEnv = getRunTimeEnv();

  return (
    <Grid item xs={4}>
      <Stack direction='column'>
        <Box sx={{ p: 2, mb: 3, cursor: 'text' }}>
          <Link
            variant='h5'
            href=''
            sx={{
              pointerEvents: 'none',
              textDecoration: 'none',
              color: 'inherit',
            }}
            onClick={e => {
              e.preventDefault();
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            }}
          >
            {nav?.title}
          </Link>
        </Box>
        <Typography sx={styles.imageContainer} variant='body1'>
          Featured
        </Typography>
        <Link
          sx={styles.imageContainer}
          href={nav?.Link?.link}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              window.open(nav?.Link?.link, '_self');
            }
          }}
        >
          <Image
            placeholder={'blur'}
            blurDataURL={BLUR_DATA_URL}
            width={280}
            height={223}
            src={`${clientSideEnv.NEXT_PUBLIC_STRAPI_SERVER || process.env.NEXT_PUBLIC_STRAPI_SERVER}${nav?.image?.data?.attributes?.url}`}
            alt={nav?.image?.data?.attributes?.alternativeText}
            quality={100}
          ></Image>
        </Link>
      </Stack>
    </Grid>
  );
};

FeaturedImage.displayName = 'FeaturedImage';
export default FeaturedImage;
